import type {
  EngagementLevel,
  EngagementThresholds,
} from '../../contracts/engagement';

/**
 * Resolve o nível a partir do score final, usando thresholds já normalizados
 * (`0 <= lowMax < mediumMax < 100`).
 *
 * low:    0..lowMax
 * medium: (lowMax+1)..mediumMax
 * high:   (mediumMax+1)..100
 */
export class EngagementLevelResolver {
  private readonly thresholds: EngagementThresholds;

  constructor(thresholds: EngagementThresholds) {
    this.thresholds = thresholds;
  }

  resolve(score: number): EngagementLevel {
    if (score <= this.thresholds.lowMax) return 'low';
    if (score <= this.thresholds.mediumMax) return 'medium';
    return 'high';
  }
}
